module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.789192dd.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }